import { render, staticRenderFns } from "./scroll_item_m.vue?vue&type=template&id=1b65ff4f&scoped=true&"
var script = {}
import style0 from "./scroll_item_m.vue?vue&type=style&index=0&id=1b65ff4f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65ff4f",
  null
  
)

export default component.exports